import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg' | number;
  fullPage?: boolean;
}

const getSizeClass = (size: 'sm' | 'md' | 'lg' | number) => {
  if (typeof size === 'number') {
    return { width: size, height: size };
  }
  switch (size) {
    case 'sm': return { width: 20, height: 20 };
    case 'lg': return { width: 56, height: 56 };
    case 'md':
    default:   return { width: 40, height: 40 };
  }
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  size = 'md',
  fullPage = false,
}) => {
  const { width, height } = getSizeClass(size);

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className="animate-spin rounded-full border-2 border-primary border-t-transparent"
        style={{ width, height }}
      />
      {message && (
        <p className="text-sm text-text-secondary">{message}</p>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-[9999]">
        {spinner}
      </div>
    );
  }

  return (
    <div className="py-16 flex items-center justify-center">
      {spinner}
    </div>
  );
};
